import { useIntl } from 'react-intl';

import { OnboardingStepConfig, OnboardingStepConfigKeys } from './types';

const useOnboardingGuideConfig = (): Record<OnboardingStepConfigKeys, OnboardingStepConfig> => {
  const intl = useIntl();

  return {
    ONBOARDING_STEP_1_ALL_ITEMS: {
      number: 1,
      title: intl.formatMessage({ id: 'listing-manager.onboarding.step-one.title' }),
      description: intl.formatMessage({ id: 'listing-manager.onboarding.step-one.description' }),
      firstStep: true,
      nextStep: 'ONBOARDING_STEP_2_CATEGORIES',
      previousStep: 'ONBOARDING_SKIPPED',
    },
    ONBOARDING_STEP_2_CATEGORIES: {
      number: 2,
      title: intl.formatMessage({ id: 'listing-manager.onboarding.step-two.title' }),
      description: intl.formatMessage({ id: 'listing-manager.onboarding.step-two.description' }),
      nextStep: 'ONBOARDING_STEP_3_ALL_OPTIONS',
      previousStep: 'ONBOARDING_STEP_1_ALL_ITEMS',
    },
    ONBOARDING_STEP_3_ALL_OPTIONS: {
      number: 3,
      title: intl.formatMessage({ id: 'listing-manager.onboarding.step-three.title' }),
      description: intl.formatMessage({ id: 'listing-manager.onboarding.step-three.description' }),
      nextStep: 'ONBOARDING_STEP_4_CREATE',
      previousStep: 'ONBOARDING_STEP_2_CATEGORIES',
    },
    ONBOARDING_STEP_4_CREATE: {
      number: 4,
      title: intl.formatMessage({ id: 'listing-manager.onboarding.step-four.title' }),
      description: intl.formatMessage({ id: 'listing-manager.onboarding.step-four.description' }),
      lastStep: true,
      nextStep: 'ONBOARDING_COMPLETED',
      previousStep: 'ONBOARDING_STEP_3_ALL_OPTIONS',
    },
  };
};

export default useOnboardingGuideConfig;
